import { action } from 'typesafe-actions';
import { CAPTCHA } from '../constants/actions';

export const setIsCaptchaValid = (isValid: boolean) => action(CAPTCHA.SET_IS_CAPTCHA_VALID, isValid);
export const setCaptchaToken = (token: string) => action(CAPTCHA.SET_CAPTCHA_TOKEN, token);